import RenderPdfContainer from '../../modules/RenderPdf/RenderPdfContainer/RenderPdfContainer';
import { AppPaths } from '../../helpers/globals/Constans.ts';

// Sync route definition
export default {
  path: `${AppPaths.RENDER_PDF}`,
  component: RenderPdfContainer,
};
